<template>
  <div class="page_404">
    404 - page not found
<!--
    [1<img src="static/img/v.png" alt="Vuetify.js" height="200">]
    [2<img src="img/v.png" alt="Vuetify.js" height="200">]
    [3<img src="v.png" alt="Vuetify.js" height="200">]
    [4<img src="static/v.png" alt="Vuetify.js" height="200">]
-->
  </div>
</template>
<!-- _____________________________________________________________________________________________________________________________________________________________ -->
<!-- ############################################################################################################################################################# -->
<script>
export default {
  name: 'page404',
  data () {
    return {
    }
  }
}
</script>
<!-- ############################################################################################################################################################# -->
<!-- ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯ -->
<style scoped>

</style>
